import React, { Component } from 'react';
import { Spinner } from '../../assets/loader/Spinner'
import logo from '../../assets/Images/design_-removebg-preview.png'
import itSolutionInovation from '../../assets/Images/itSolutionInovation.png'
import customer from '../../assets/Images/customer.png'
import quality from '../../assets/Images/quality.png'
import Ai from '../../assets/Images/ai.gif'
import Python from '../../assets/Images/Python.webp'
import MS_Software from '../../assets/Images/MS_SoftwareBG.png'
import Angular_gif from '../../assets/Images/Angular_gif.gif'
import customizesdevelopment from '../../assets/Images/customizesdevelopment.png'


import './Products.css'

export class Products extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }



  handleNavigationStart = () => {
    this.setState({ loading: true });
  };

  handleNavigationEnd = () => {
    this.setState({ loading: false });
  };

  render() {
    const { loading } = this.state;
    const aiTechnologies = [
      {
        title: "AI-Powered Solutions (In Progress)",
        description:
          "We are actively exploring AI-driven technologies, including machine learning and automation, to enhance our software solutions.",
      },
      {
        title: "Ongoing AI Training",
        description:
          "Our team is continuously upskilling in AI-based image processing, predictive analytics, and intelligent automation to integrate advanced capabilities into our projects.",
      },
      {
        title: "Future AI Implementation",
        description:
          "We are working on adopting AI technologies to improve efficiency in document management, search optimization, and business intelligence.",
      },
    ];

    return (
      <div>
        {loading && <Spinner />}  {/* Conditionally render the spinner */}
        <div className='bg_img'>
          <div className="row ">
            <div className="col-lg-6 col-md-12 col-sm-12 ">

              <img src={itSolutionInovation} className="responsive-image" />
            </div>

            <div className="col-lg-5 col-md-12 col-sm-12 text_color">
              <h1 className='Prod_H_text'>Innovative  Software Services</h1>
              <p>Transform your business with our innovative software services. Explore our product offerings and let us help you take the next step toward digital excellence.</p>

            </div>
          </div>
        </div>
        <div>
          <h2 className='services'>Our Services</h2>
        </div>
        <div className='row'>

          <div className="col-8 e-card playing">
            <div className="image"></div>

            <div className="wave"></div>
            <div className="wave"></div>
            <div className="wave"></div>

            <div className="  infotop">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                className="icon"
              >
                <path
                  fill="currentColor"
                  d="M19.4133 4.89862L14.5863 2.17544C12.9911 1.27485 11.0089 1.27485 9.41368 2.17544L4.58674
  4.89862C2.99153 5.7992 2 7.47596 2 9.2763V14.7235C2 16.5238 2.99153 18.2014 4.58674 19.1012L9.41368
  21.8252C10.2079 22.2734 11.105 22.5 12.0046 22.5C12.6952 22.5 13.3874 22.3657 14.0349 22.0954C14.2204
  22.018 14.4059 21.9273 14.5872 21.8252L19.4141 19.1012C19.9765 18.7831 20.4655 18.3728 20.8651
  17.8825C21.597 16.9894 22 15.8671 22 14.7243V9.27713C22 7.47678 21.0085 5.7992 19.4133 4.89862ZM4.10784
  14.7235V9.2763C4.10784 8.20928 4.6955 7.21559 5.64066 6.68166L10.4676 3.95848C10.9398 3.69152 11.4701
  3.55804 11.9996 3.55804C12.5291 3.55804 13.0594 3.69152 13.5324 3.95848L18.3593 6.68166C19.3045 7.21476
  19.8922 8.20928 19.8922 9.2763V9.75997C19.1426 9.60836 18.377 9.53091 17.6022 9.53091C14.7929 9.53091
  12.1041 10.5501 10.0309 12.3999C8.36735 13.8847 7.21142 15.8012 6.68783 17.9081L5.63981 17.3165C4.69466
  16.7834 4.10699 15.7897 4.10699 14.7235H4.10784ZM10.4676 20.0413L8.60933 18.9924C8.94996 17.0479 9.94402
  15.2665 11.4515 13.921C13.1353 12.4181 15.3198 11.5908 17.6022 11.5908C18.3804 11.5908 19.1477 11.6864
  19.8922 11.8742V14.7235C19.8922 15.2278 19.7589 15.7254 19.5119 16.1662C18.7615 15.3596 17.6806 14.8528
   16.4783 14.8528C14.2136 14.8528 12.3781 16.6466 12.3781 18.8598C12.3781 19.3937 12.4861 19.9021 12.68
   20.3676C11.9347 20.5316 11.1396 20.4203 10.4684 20.0413H10.4676Z"
                ></path>
              </svg>
              <div className='row '>
                <div class="col-4 text-container">
                  <h3>Document Management Solutions</h3>
                  <ul>
                    <li>FTS</li>
                    <li>Document tracking systems</li>
                    <li>Loan Clouser</li>
                    <li>Retrievals</li>
                    <li>Distraction</li>
                  </ul>

                </div>
                <div className='col-8'>
                  <ul >
                    <li><label>FTS (File Tracking System)</label>: A centralized system to monitor, manage, and locate files at any stage in their lifecycle.</li>
                    <li> <label>Document Tracking Systems</label>: Tailored solutions to maintain full visibility and control over document movement, including automated status updates and notifications.</li>
                    <li><label>Loan Closure Management</label>:Automating workflows for loan closure documents, reducing manual intervention, and ensuring compliance.</li>
                    <li> <label>Retrieval Automation</label>: Implementing intelligent search and indexing tools to facilitate fast and accurate document retrievals</li>
                  </ul>
                </div>





              </div>
            </div>
          </div>




        </div>


        {/* black */}

        {/* <div class="ag-format-container">
  <div class="ag-courses_box">
    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          UI/Web&amp;Graph design for teenagers 11-17&#160;years old
        </div>

        <div class="ag-courses-item_date-box">
          Start:
          <span class="ag-courses-item_date">
            04.11.2022
          </span>
        </div>
      </a>
    </div>

    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          UX/UI Web-Design&#160;+ Mobile Design
        </div>

        <div class="ag-courses-item_date-box">
          Start:
          <span class="ag-courses-item_date">
            04.11.2022
          </span>
        </div>
      </a>
    </div>

    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          Annual package "Product+UX/UI+Graph designer&#160;2022"
        </div>

        <div class="ag-courses-item_date-box">
          Start:
          <span class="ag-courses-item_date">
            04.11.2022
          </span>
        </div>
      </a>
    </div>

    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          Graphic Design
        </div>

        <div class="ag-courses-item_date-box">
          Start:
          <span class="ag-courses-item_date">
            04.11.2022
          </span>
        </div>
      </a>
    </div>

    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          Motion Design
        </div>

        <div class="ag-courses-item_date-box">
          Start:
          <span class="ag-courses-item_date">
            30.11.2022
          </span>
        </div>
      </a>
    </div>

    <div class="ag-courses_item">
      <a href="#" class="ag-courses-item_link">
        <div class="ag-courses-item_bg"></div>

        <div class="ag-courses-item_title">
          Front-end development&#160;+ jQuery&#160;+ CMS
        </div>
      </a>
    </div>

   

   

  </div>
</div> */}
        {/* blck end */}


        <div class="cards">

          <article class="information [ card ]">
            <span class="tag">
              <img className='imgStyle' src={customizesdevelopment} />
              <h2 class=" tag title">Custom Software Development</h2>
              <p class="tag info">We specialize in creating bespoke software solutions designed to address unique business challenges and optimize operations. we deliver scalable and efficient applications tailored to your specific needs.</p>
            </span>
            {/* <button class="button">
			<span>Learn more</span>
			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="none">
				<path d="M0 0h24v24H0V0z" fill="none" />
				<path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" fill="currentColor" />
			</svg>
		</button> */}
          </article>
          <article class="plan [ card ]">
            <div class="inner">

              {/* <span class="pricing">
				<span>
					$56 <small>/ m</small>
				</span>
			</span> */}
              <h2 class="title">API Engineering</h2>
              <p class="info"> Custom & high-performance APIs tailored to your business requirements.</p>
              <ul class="features">
                <li>
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" fill="currentColor" />
                    </svg>
                  </span>
                  <span> API Integration</span>
                </li>
                <li>
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" fill="currentColor" />
                    </svg>
                  </span>
                  <span>System Integration</span>
                </li>
                <li>
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z" fill="currentColor" />
                    </svg>
                  </span>
                  <span>API Development</span>
                </li>
              </ul>

            </div>
          </article>
          <article class="information [ card ]">
            <span class="tags">
              <img className='imgStyle_support' src={MS_Software} />
              <h2 class=" tags title">Software Maintenance & Support</h2>
              {/* <p class="tag info">We specialize in creating bespoke software solutions designed to address unique business challenges and optimize operations. we deliver scalable and efficient applications tailored to your specific needs.</p> */}
              <ul>
                {/*    
    <li>Security Audits & Compliance Checks</li> */}
                <li>Scheduling Continuous <strong>Backup</strong> </li>
                <li>Yearly <strong>50</strong> Hours of Free Customization</li>
                <li><strong>Immediate Assistance</strong> for Critical Issues</li>
                <li><strong>Data Security</strong> – Ensuring encryption, access control, and secure data handling.</li>

              </ul>
            </span>

            {/* <button class="button">
			<span>Learn more</span>
			<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="none">
				<path d="M0 0h24v24H0V0z" fill="none" />
				<path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" fill="currentColor" />
			</svg>
		</button> */}
          </article>
        </div>


        <h1 class="Tech" >Our Core Technologies...</h1>

        <div class="cards-list">
 
  <div class="card_T 1">
    <div class="card_image"> <img src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExOTZ1cnFjbGZpMDgzdjB6OW04N3R3YWhtcTJmazVlcTFqNTB5OGw2MSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/vISmwpBJUNYzukTnVx/giphy.gif" /> </div>
    <div class="card_title title-white">
      <p>Db</p>
    </div>
  </div>
  
    <div class="card_T 2">
    <div class="card_image">
      <img src={Angular_gif} />
      </div>
    <div class="card_title title-white">
      <p>Angular</p>
    </div>
  </div>
  
  <div class="card_T 3">
    <div class="card_image">
      <img src={Python} />
    </div>
    <div class="card_title">
      <p></p>
    </div>
  </div>
    
    <div class="card_T 4">
    <div class="card_image">
      <img src={Ai} />
      </div>
    <div class="card_title title-black">
      <p></p>
    </div>
    </div>
  
  </div>


  <div className="technology-container">
      <h2>AI & Emerging Technologies</h2>
      <ul>
        {aiTechnologies.map((tech, index) => (
          <li key={index}>
            <strong>{tech.title}</strong>
            <p>{tech.description}</p>
          </li>
        ))}
      </ul>
    </div>








    {/* pricing */}
    {/* <div className="pricing-container">
      <h1>Our Pricing Plans</h1>
      <p>Flexible and Scalable Solutions for Your Business</p>

      <div className="pricing-cards">
     
        <div className="pricing-card">
          <h2>Basic Plan</h2>
          <p><strong>Initial Setup Fee:</strong> $500</p>
          <p><strong>Monthly Subscription (First Year):</strong> $100/month</p>
          <p><strong>Post-First-Year Subscription:</strong> $120/month</p>
          <ul>
            <li>Document Tracking</li>
            <li>Basic Reporting</li>
            <li>Standard Support</li>
          </ul>
          <button className="btn">Get Started</button>
        </div>

     
        <div className="pricing-card">
          <h2>Pro Plan</h2>
          <p><strong>Initial Setup Fee:</strong> $1000</p>
          <p><strong>Monthly Subscription (First Year):</strong> $250/month</p>
          <p><strong>Post-First-Year Subscription:</strong> $300/month</p>
          <ul>
            <li>Advanced Document Tracking</li>
            <li>Custom Reporting</li>
            <li>Priority Support</li>
          </ul>
          <button className="btn">Get Started</button>
        </div>

  
        <div className="pricing-card">
          <h2>Enterprise Plan</h2>
          <p><strong>Initial Setup Fee:</strong> $2000</p>
          <p><strong>Monthly Subscription (First Year):</strong> $500/month</p>
          <p><strong>Post-First-Year Subscription:</strong> $600/month</p>
          <ul>
            <li>Full Document Management System</li>
            <li>Advanced Customization</li>
            <li>Dedicated Account Manager</li>
            <li>24/7 Support</li>
          </ul>
          <button className="btn">Contact Us</button>
        </div>
      </div>
    </div> */}

    {/* pricing end */}




{/* process flow check of development */}






<div class="process-container">
  <h1>Our Development Process</h1>
  <p>Here’s how we bring your project to life.</p>

  <div class="process-steps">
    <div class="step">
      <div class="step-content">
        <img src="https://www.amosoft.com/images/editarget/analysis.png" alt="Requirement Gathering" />
        <h2>Requirement Gathering</h2>
        <p>Understanding your needs and business goals is crucial for us. We take the time to understand your requirements fully before starting any work.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://th.bing.com/th/id/OIP.METakhjDLeRruaQruEyFHQAAAA?rs=1&pid=ImgDetMain" alt="Flow Creation" />
        <h2>Flow Creation</h2>
        <p>We define and outline the flow of the application, mapping out the user's journey and interactions.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://cdn0.iconfinder.com/data/icons/3d-dynamic-gradient/512/figma-dynamic-gradient.png" alt="Figma Design" />
        <h2>Figma Design</h2>
        <p>Our design team will create high-fidelity wireframes and prototypes using Figma to visualize the final product.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://img.freepik.com/premium-vector/vector-hand-coding-website-concept-illustration_987561-8.jpg" alt="Development" />
        <h2>Development</h2>
        <p>Our developers bring the design to life, implementing features and functionality as per your requirements.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://thumbs.dreamstime.com/z/customer-service-t…-headset-microphone-computer-laptop-292219254.jpg" alt="Weekly Updates" />
        <h2>Weekly Updates of UAT</h2>
        <p>Every week, we share progress with you and gather feedback to ensure we're on track and meeting your expectations.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://static.vecteezy.com/system/resources/previews/029/926/656/original/uat-user-acceptance-testing-software-testing-concept-development-quality-stock-illustration-vector.jpg" alt="Final UAT" />
        <h2>Final UAT</h2>
        <p>Once development is complete, the final version undergoes User Acceptance Testing to ensure everything works as intended.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://www.bidout-wp.egenslab.com/wp-content/uploads/2022/10/how-work1.png" alt="Login Credentials" />
        <h2>Sharing Login Credentials for Testing</h2>
        <p>We provide you with login credentials to test the system in a secure demo environment before the official release.</p>
      </div>
    </div>

    <div class="step">
      <div class="step-content">
        <img src="https://5.imimg.com/data5/SELLER/Default/2023/8/338793693/VV/IN/JB/9375037/ssl-certificate-services-500x500.jpg" alt="SSL Application" />
        <h2>Applying SSL</h2>
        <p>We apply SSL certification to ensure that your application is secure and protected from cyber threats.</p>
      </div>
    </div>

    
  </div>
</div>

      </div>


    )
  }
}